import React, { Dispatch, SetStateAction } from 'react';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import LongTermSVG from '../../../../../img/autoAccountWorkflow/longTerm.svg';
import RetirementSVG from '../../../../../img/autoAccountWorkflow/retirement.svg';
import { FinancialGoal } from '../../AutoAccountWorkflow.types';
import { VisualPickerButtonContainer } from '../../../../CommonComponents/OPL/VisualPickerButton/VisualPickerButtonContainer';
import { Content, StickyFooter } from '../../../../CommonComponents/OPL/StickyFooter/StickyFooter';
import { useResetModuleWrapperStyles } from '../../../../_hooks/useResetModuleWrapperStyles';
import { StepCard } from '../StepCard/StepCard';

interface WorkflowSelectionProps {
  setActiveWorkflow: Dispatch<SetStateAction<FinancialGoal | null>>;
}

export const WorkflowSelection: React.FC<WorkflowSelectionProps> = ({ setActiveWorkflow }) => {
  useResetModuleWrapperStyles();

  return (
    <Box minWidth={864} mt={96}>
      <Content>
        <StepCard>
          <Text color="neutral.700" fontSize="h3" fontWeight={500}>
            What’s your main financial goal?
          </Text>

          <Box display="flex" justifyContent="space-between" mt="16">
            <Box display="flex" flex={1}>
              <VisualPickerButtonContainer
                onClick={() => setActiveWorkflow(FinancialGoal.LongTerm)}
                mr="16"
              >
                <Box display="flex" flexDirection="column" px="8" alignItems="center">
                  <LongTermSVG />
                  <Text color="neutral.700" fontWeight={500} mt="16" textAlign="center">
                    I’m investing for the long term
                  </Text>
                  <Text color="neutral.500" fontSize="small" mt="4" textAlign="center">
                    A flexible account designed for longer term saving will get you started.
                  </Text>
                </Box>
              </VisualPickerButtonContainer>
            </Box>

            <Box display="flex" flex={1}>
              <VisualPickerButtonContainer
                onClick={() => setActiveWorkflow(FinancialGoal.Retirement)}
              >
                <Box display="flex" flexDirection="column" px="8" alignItems="center">
                  <RetirementSVG />
                  <Text color="neutral.700" fontWeight={500} mt="16" textAlign="center">
                    I’m saving for retirement
                  </Text>
                  <Text color="neutral.500" fontSize="small" mt="4" textAlign="center">
                    A Traditional IRA, Roth IRA or a 401(k)-to-IRA rollover allows your savings to
                    grow tax-free.
                  </Text>
                </Box>
              </VisualPickerButtonContainer>
            </Box>
          </Box>
        </StepCard>
      </Content>

      <StickyFooter progress={0} />
    </Box>
  );
};
